<div class="auth-login position-relative overflow-hidden d-flex align-items-center justify-content-center px-7 px-xxl-0 rounded-3 h-n20">
    <div class="position-relative w-100">
        <canvas id="hero-shader" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0;"></canvas>
        <div class="auth-login-wrapper card mb-0 container position-relative z-1 h-100 mh-n100" data-simplebar>
            <div class="card-body">
                <!--
                <a href="../main/index.html" class="">
                    <img src="../assets/images/logos/logo-dark.svg" class="light-logo" alt="Logo-Dark" />
                    <img src="../assets/images/logos/logo-light.svg" class="dark-logo" alt="Logo-light" />
                </a>
                -->
                <div class="row align-items-center justify-content-around pt-6 pb-5">
                    <div class="col-lg-6 col-xl-5 d-none d-lg-block">
                        <div class="text-center text-lg-start">
                            <img src="/assets/img/auth-logo.png" alt="spike-img" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-5">
                        <img src="/assets/img/logo-horizontal.svg" alt="TmplVision" class="mb-4" style="max-width: 480px; height: auto;">
                        <p class="fs-4 mb-7" style="color: var(--bs-body-color);">Sign in to manage your templates and generate documents via API.</p>
                        <!--
                        <div class="d-flex align-items-center gap-3">
                            <a class="btn btn-white w-100 text-dark border fw-bold d-flex align-items-center justify-content-center rounded-1 py-6 shadow-none" href="javascript:void(0)" role="button">
                                <img src="../assets/images/svgs/google-icon.svg" alt="spike-img" class="img-fluid me-2" width="24" height="24">
                                <span class="d-none d-sm-block me-1 flex-shrink-0">Sign in with</span>Google
                            </a>
                            <a class="btn btn-white w-100 text-dark border fw-bold d-flex align-items-center justify-content-center rounded-1 py-6 shadow-none" href="javascript:void(0)" role="button">
                                <img src="../assets/images/svgs/icon-facebook.svg" alt="spike-img" class="img-fluid me-2" width="24" height="24">
                                <span class="d-none d-sm-block me-1 flex-shrink-0">Sign in with</span>FB
                            </a>
                        </div>
                        <div class="position-relative text-center my-7">
                            <p class="mb-0 fs-3 px-3 d-inline-block bg-white z-1 position-relative">or sign in with</p>
                            <span class="border-top w-100 position-absolute top-50 start-50 translate-middle"></span>
                        </div>
                        -->
                        <form data-id="form-login">
                            <div class="mb-3">
                                <label for="loginRegion"
                                       class="form-label fw-bold">Region</label>
                                <select class="form-select py-6"
                                        id="loginRegion"
                                        name="region"
                                        data-id="select-region"
                                        required>
                                    <option value="" disabled selected>Select your region</option>
                                    <option value="eu">Europe (EU)</option>
                                    <option value="us">United States (US)</option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <label for="loginEmail"
                                       class="form-label fw-bold">Email</label>
                                <input type="email"
                                       class="form-control py-6"
                                       id="loginEmail"
                                       name="email"
                                       aria-describedby="emailHelp"
                                       required>
                            </div>
                            <div class="mb-9">
                                <label for="loginPassword"
                                       class="form-label fw-bold">Password</label>
                                <input type="password"
                                       class="form-control py-6"
                                       id="loginPassword"
                                       name="password"
                                       required>
                            </div>
                            <div class="d-md-flex align-items-center justify-content-between mb-1 pb-1">
                                <div data-id="login-error-container"
                                     class="invalid-feedback mb-3"></div>
                            </div>
                            <div class="d-md-flex align-items-center justify-content-between mb-7 pb-1">
                                <div class="form-check mb-3 mb-md-0">
                                    <input class="form-check-input primary"
                                           type="checkbox"
                                           name="checkRememberDevice"
                                           value=""
                                           id="flexCheckChecked" checked>
                                    <label class="form-check-label text-dark fs-3" for="flexCheckChecked">
                                        Remember this Device
                                    </label>
                                </div>
                                <a class="text-primary fw-medium fs-3 fw-bold" href="/forgot-password">Forgot Password ?</a>
                            </div>
                            <button data-id="btn-login"
                                    type="button"
                                    class="btn btn-primary w-100 mb-7 rounded-pill">Sign In</button>
                            <button data-id="btn-login-loading"
                                    class="btn btn-primary w-100 mb-7 rounded-pill"
                                    type="button"
                                    style="display: none;"
                                    disabled="">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </button>
                            <div class="d-flex align-items-center">
                                <p class="fs-3 mb-0 fw-medium">New to Spike?</p>
                                <a class="text-primary fw-bold ms-2 fs-3" href="/register">Create an account</a>
                            </div>
                            <p class="fs-2 mt-4 mb-0"><a class="text-muted" href="javascript:void(0)" data-open-cookie-settings>Cookie Settings</a></p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="dark-transparent sidebartoggler"></div>
